import React from "react";
import { HalfSplitRow } from "@components/templates/layouts/half-split-row/half-split-row";
import styles from "./bulk-data-acquisition-type-and-interval-inputs-wrapper.module.scss";
import { LabelPlusDropDownWithBlackBackground } from "@components/molecules/label-plus-drop-down-with-black-background/label-plus-drop-down-with-black-background";
import { LabelPlusInputAndDropDown } from "@components/molecules/label-plus-input-and-drop-down/label-plus-input-and-dropdown";
import { DataAcquisitionTypeMonitoringInfoIconAndTextWrapper } from "@components/molecules/data-acquisition-type-monitoring-info-icon-and-text-wrapper/data-acquisition-type-monitoring-info-icon-and-text-wrapper";
import { useI18N } from "@src/language/language-context";

const cssClassName = "bulk-data-acquisition-type-and-interval-inputs-wrapper";

interface BulkDataAcquisitionTypeAndIntervalInputsWrapperPropTypes {
  dataAcquisitionTypeDropdownValue: string;
  pollingIntervalInSeconds: number;
  callbackForDataAcquisitionTypeValue: (value: string) => void;
  callbackForPollingIntervalTime: (value: number) => void;
}

export const BulkDataAcquisitionTypeAndIntervalInputsWrapper = ({
  dataAcquisitionTypeDropdownValue,
  pollingIntervalInSeconds,
  callbackForDataAcquisitionTypeValue,
  callbackForPollingIntervalTime,
}: BulkDataAcquisitionTypeAndIntervalInputsWrapperPropTypes) => {
  const i18n = useI18N();
  const manageVisualisationOfSecondHalfOfRow = (
    dataAcquisitionTypeDropdownValue,
  ) => {
    switch (dataAcquisitionTypeDropdownValue) {
      case "Mixed":
        return <></>;
      case "Polling":
        return (
          <LabelPlusInputAndDropDown
            labelText={i18n(
              "modules.bulkEditDataAcquisitionModal.updateEveryInputAndDropDownLabel",
            )}
            intervalInSeconds={pollingIntervalInSeconds}
            callback={callbackForPollingIntervalTime}
          />
        );
      case "Monitoring":
        return <DataAcquisitionTypeMonitoringInfoIconAndTextWrapper />;
      default:
        break;
    }
  };

  // key label pairs
  const dropDownValuesAndLabels = {
    Mixed: "Mixed",
    Polling: "Polling",
    Monitoring: "Monitoring",
  };

  return (
    <div className={styles[cssClassName]}>
      <HalfSplitRow>
        <LabelPlusDropDownWithBlackBackground
          dropDownId="bulk-data-acquisition-type-dropdown"
          labelText={i18n(
            "modules.bulkEditDataAcquisitionModal.dataAcquisitionTypeDropDownLabel",
          )}
          dropDownValue={dataAcquisitionTypeDropdownValue}
          dropDownValuesAndLabels={dropDownValuesAndLabels}
          callback={callbackForDataAcquisitionTypeValue}
        />
        {dataAcquisitionTypeDropdownValue &&
          manageVisualisationOfSecondHalfOfRow(
            dataAcquisitionTypeDropdownValue,
          )}
      </HalfSplitRow>
    </div>
  );
};
